<template>
  <div class="main">
    <img class="banner" src="@/assets/images/pdt-lh2.png" alt="">
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="19">
        <img src="@/assets/images/cebei/cebei01.jpg" alt="" />
        <img src="@/assets/images/cebei/cebei02.png" alt="" />
        <img src="@/assets/images/cebei/cebei03.png" alt="" />
        <img src="@/assets/images/cebei/cebei04.png" alt="" />
        <img src="@/assets/images/cebei/cebei05.png" alt="" />
        <img src="@/assets/images/cebei/cebei06.png" alt="" />
        <img src="@/assets/images/cebei/cebei07.png" alt="" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Product_amh",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>

.el-row{
  justify-content: center;
  text-align: center;
  .el-col{
    img{
      width: 100%;
      max-width: 800px;
      height: auto;
    }
  }
}
</style>
